export const HomeScreenTileTypes = Object.freeze({
  BI_REPORT: 'BI_REPORT',
  IMAGE: 'IMAGE',
  STATIC_TEXT: 'STATIC_TEXT',
});

export const HomeScreenTileTypeList = Object.freeze([
  { value: HomeScreenTileTypes.BI_REPORT, label: 'BI riport' },
  { value: HomeScreenTileTypes.IMAGE, label: 'Kép' },
  { value: HomeScreenTileTypes.STATIC_TEXT, label: 'Statikus szöveg' },
]);

export const HomeScreenLinkTypes = Object.freeze({
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL',
});

export const HomeScreenLinkTypeList = Object.freeze([
  { value: HomeScreenLinkTypes.INTERNAL, label: 'Belső hivatkozás' },
  { value: HomeScreenLinkTypes.EXTERNAL, label: 'Külső hivatkozás' },
]);

const byteArrayToBase64 = (bytes) => {
  let binary = '';
  const chunkSize = 8192;

  for (let index = 0; index < bytes.length; index += chunkSize) {
    binary += String.fromCharCode(...bytes.slice(index, index + chunkSize));
  }

  return window.btoa(binary);
};

const getImageDataBase64 = (imageData) => {
  if (typeof imageData === 'string') return imageData.trim();
  if (Array.isArray(imageData)) return byteArrayToBase64(imageData);
  if (Array.isArray(imageData?.data)) return byteArrayToBase64(imageData.data);

  return '';
};

export const getHomeScreenImageSource = (tile) => {
  const imageDataBase64 = getImageDataBase64(tile?.imageDataBase64 ?? tile?.imageData);

  if (!imageDataBase64) return '';
  if (imageDataBase64.startsWith('data:')) return imageDataBase64;

  return `data:${tile.imageMimeType};base64,${imageDataBase64}`;
};

export const getHomeScreenBackgroundImageSource = (homeScreen) => {
  const imageDataBase64 = getImageDataBase64(homeScreen?.backgroundImageDataBase64 ?? homeScreen?.backgroundImageData);

  if (!imageDataBase64) return '';
  if (imageDataBase64.startsWith('data:')) return imageDataBase64;

  return `data:${homeScreen.backgroundImageMimeType};base64,${imageDataBase64}`;
};

export const normalizeHomeScreenBackgroundImage = (homeScreen) => {
  const imageSource = getHomeScreenBackgroundImageSource(homeScreen);
  const mimeType = imageSource.match(/^data:([^;,]+)/)?.[1];

  return {
    ...homeScreen,
    backgroundImageDataBase64: imageSource || null,
    backgroundImageMimeType: homeScreen?.backgroundImageMimeType || mimeType || null,
    _backgroundImageChanged: false,
  };
};

export const normalizeHomeScreenImage = (tile) => {
  const imageSource = getHomeScreenImageSource(tile);
  const mimeType = imageSource.match(/^data:([^;,]+)/)?.[1];

  return {
    ...tile,
    imageDataBase64: imageSource,
    imageMimeType: tile.imageMimeType || mimeType || '',
  };
};
